import { Flex } from "antd";
import React from "react";
import { Title } from "~/shared/ui/Text/Title";
import s from "./CommentWrapper.less";

interface ICommentWrapperProps {
  title: string;
  comment: string;
  style?: React.CSSProperties;
}

export const CommentWrapper = ({
  title,
  comment,
  style,
}: ICommentWrapperProps) => {
  return (
    <Flex className={s.container} style={style} vertical>
      <Title className={s.title} size="sm" title={title} />
      <span className={s.comment}>{comment}</span>
    </Flex>
  );
};
